// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__btpoo","badge":"styles_badge__7wUaG","flag":"styles_flag__OEgB1","text":"styles_text__MOTXz"};